import { BUILDER_RIGHT_PANEL_ID } from '../../constants/builder';
import { ROOT_NODE_ID, useBuilderStore } from '../../stores/builder.store';

/**
 * Open the correct edit dialog if the builder is editable
 */
export const openEditDialog = () => {
  const { currentRecipe, selectedRecipeNode, update } =
    useBuilderStore.getState();

  // NOTE: shortcuts stay bound under the greeter and after leaving the builder
  if (!currentRecipe?.id) {
    return;
  }

  // reference vertices are read-only pointers to another node — no edit dialog
  if (selectedRecipeNode?.isReference) {
    return;
  }

  // open the edit dialog for the root node
  if (selectedRecipeNode?.id === ROOT_NODE_ID) {
    return update({ showEditRecipeDialog: true });
  }

  // open the edit options dialog if the selected node has options
  if (selectedRecipeNode?.val?.options?.length > 0) {
    return update({ showEditRecipeOptionsDialog: true });
  }

  // open the edit nested recipe dialog for nested custom recipes that aren't the root
  if (
    selectedRecipeNode?.id !== ROOT_NODE_ID &&
    selectedRecipeNode?.isCustomRecipe
  ) {
    return update({ showEditNestedRecipeDialog: true });
  }
};

/**
 * Open the correct delete dialog if the builder is editable
 */
export const openDeleteDialog = () => {
  const { currentRecipe, selectedRecipeNode, update } =
    useBuilderStore.getState();

  if (!currentRecipe?.id || selectedRecipeNode?.id === ROOT_NODE_ID) {
    return;
  }

  update({ showDeleteRecipeDialog: true });
};

/**
 * Open the add recipe dialog if the builder is editable
 */
export const openAddRecipeDialog = () => {
  const { currentRecipe, update } = useBuilderStore.getState();

  if (!currentRecipe?.id) {
    return;
  }

  update({ showRecipeFinderPanel: true });
};

export const promptForRecipeOverride = async (id): Promise<boolean> => {
  await useBuilderStore.getState().fetchCustomRecipes();
  if (useBuilderStore.getState().customRecipes.some((r) => r.id === id)) {
    useBuilderStore.getState().update({ showOverrideRecipeDialog: true });
    return true;
  }
  return false;
};
export const measureRightPanelWidth = (
  rightSideBarWidth: string,
  update: (n) => void
) => {
  const rightPanel = document.getElementById(BUILDER_RIGHT_PANEL_ID);
  if (rightPanel) {
    const newWidth = `${rightPanel.offsetWidth}px`;
    if (newWidth !== rightSideBarWidth) {
      update({ rightSideBarWidth: newWidth });
    }
  }
};
